import StoryReader from './StoryReader'

export default StoryReader
